document.addEventListener('DOMContentLoaded', () => {
  // アンカーリンク要素を全て選択
  const anchorLinks = document.querySelectorAll(
    'a[href^="#"]'
  ) as NodeListOf<HTMLAnchorElement>;

  // CSS変数の値を取得
  const rootStyle = getComputedStyle(document.documentElement);
  const buffer = parseInt(rootStyle.getPropertyValue('--buffer'), 10);

  // 各リンクに対してイベントリスナーを追加
  anchorLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      // デフォルトのイベントをキャンセル（ページが突然移動するのを防ぐ）
      event.preventDefault();

      // リンクのhref属性からアンカーのIDを取得
      const anchorId = link.getAttribute('href') || '';

      // 対象のアンカー要素を選択
      const targetElement = document.querySelector(anchorId) as HTMLElement;

      // アンカー要素の位置までスムーズにスクロール（ヘッダーの高さ分だけ上にずらす）
      window.scrollTo({
        top: targetElement.offsetTop - buffer,
        behavior: 'smooth', // アニメーション効果を指定
      });
    });
  });

  if (location.hash) {
    setTimeout(() => {
      window.scrollBy(0, -buffer);
    }, 100);
  }
});

// document.addEventListener('DOMContentLoaded', () => {
//   const handleScroll = (targetElement: HTMLElement | null) => {
//     if (targetElement) {
//       const rootStyle = getComputedStyle(document.documentElement);
//       const buffer = parseInt(rootStyle.getPropertyValue('--buffer'), 10);
//       window.scrollTo({
//         top: targetElement.offsetTop - buffer,
//         behavior: 'smooth',
//       });
//     }
//   };

//   const handleHashChange = () => {
//     const hash = window.location.hash;
//     const targetElement = hash ? document.querySelector(hash) : null;
//     handleScroll(targetElement as HTMLElement);
//   };

//   const handleLoad = () => {
//     const hash = window.location.hash;
//     const targetElement = hash ? document.querySelector(hash) : null;
//     handleScroll(targetElement as HTMLElement);
//   };

//   // ページ読み込み時のハンドリング
//   handleHashChange();
//   window.addEventListener('load', handleLoad);

//   // リンククリック時のハンドリング
//   const anchorLinks =
//     document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
//   anchorLinks.forEach((link) => {
//     link.addEventListener('click', (event: MouseEvent) => {
//       event.preventDefault();
//       const targetId = link.getAttribute('href');
//       if (targetId) {
//         const newUrl = `${window.location.origin}${window.location.pathname}${targetId}`;
//         window.location.href = newUrl;
//         setTimeout(() => handleScroll(document.querySelector(targetId)), 0);
//       }
//     });
//   });

//   // hashchange イベントのハンドリング
//   window.addEventListener('hashchange', handleHashChange);
// });
